import React from 'react';
import SharedOrderEdit from '../shared/orders/OrderEditSteps';

const OrderEdit = ({ match }) => <SharedOrderEdit id={match.params.id} />;

export default OrderEdit;
